import { sellerConstants } from '../../_constants/seller.constants';
import { editSellerService } from '../../_services/';
import { sellerActions } from '../seller.actions';

export const deleteSellerAction = {
    deleteSeller
};

function deleteSeller(id, callback) {

    return dispatch => {
        dispatch(request());
        editSellerService.deleteSeller(id)
            .then(
                data => {
                    dispatch(success(data));
                    dispatch(sellerActions.getSellers());
                    if (callback) {
                        callback(data)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request(id) { return { type: sellerConstants.REQUEST_DELETE_SELLER, id } }
    function success(data) { return { type: sellerConstants.RECEIVE_DELETE_SELLER, data } }
    function failure(error) { return { type: sellerConstants.DELETE_SELLER_ERROR, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/sellers/deleteSeller.actions.js